"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaffViewFields = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const StaticFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/StaticFieldType/StaticFieldType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const ViewFieldKey_1 = __importDefault(require("../ViewFieldKey"));
exports.StaffViewFields = {
    [ViewFieldKey_1.default.STAFF_POSITIONTEAMS]: {
        key: ViewFieldKey_1.default.STAFF_POSITIONTEAMS,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        propertyName: 'teams',
        label: () => lib_i18n_1.default.t('staff-teams'),
        description: () => lib_i18n_1.default.t('staff-teams-description'),
        sortable: false,
        width: 150,
        gqlFields: 'positions { id, team { id, title } }',
    },
    [ViewFieldKey_1.default.STAFF_POSITIONS]: {
        key: ViewFieldKey_1.default.STAFF_POSITIONS,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        propertyName: 'positions',
        label: () => lib_i18n_1.default.t('positions'),
        description: () => lib_i18n_1.default.t('positions-description'),
        sortable: false,
        width: 150,
        gqlFields: 'positions { id, title }',
    },
    [ViewFieldKey_1.default.STAFF_TYPE]: {
        key: ViewFieldKey_1.default.STAFF_TYPE,
        fieldType: StaticFieldType_1.default.USER_TYPE,
        propertyName: 'staffType',
        label: () => lib_i18n_1.default.t('staff-type'),
        description: () => lib_i18n_1.default.t('staff-type-description'),
        sortable: true,
        width: 110,
        gqlFields: 'staffType',
    },
    [ViewFieldKey_1.default.STAFF_INVITESTATUS]: {
        key: ViewFieldKey_1.default.STAFF_INVITESTATUS,
        fieldType: StaticFieldType_1.default.STAFF_WEBSTATUS,
        propertyName: 'inviteStatus',
        label: () => lib_i18n_1.default.t('staff-invite-to-web-status'),
        description: () => lib_i18n_1.default.t('staff-invite-to-web-status-description'),
        sortable: false,
        width: 120,
        gqlFields: 'inviteStatus',
    },
    [ViewFieldKey_1.default.STAFF_INVITETOAPPSTATUS]: {
        key: ViewFieldKey_1.default.STAFF_INVITETOAPPSTATUS,
        fieldType: StaticFieldType_1.default.STAFF_APPSTATUS,
        propertyName: 'inviteToAppStatus',
        label: () => lib_i18n_1.default.t('staff-invite-to-app-status'),
        description: () => lib_i18n_1.default.t('staff-invite-to-app-status-description'),
        sortable: true,
        width: 120,
        gqlFields: 'inviteToAppStatus',
    },
    [ViewFieldKey_1.default.STAFF_LASTLOGGEDIN]: {
        key: ViewFieldKey_1.default.STAFF_LASTLOGGEDIN,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'lastLoggedIn',
        label: () => lib_i18n_1.default.t('staff-last-loggedin'),
        description: () => lib_i18n_1.default.t('staff-last-loggedin-description'),
        sortable: true,
        width: 120,
        gqlFields: 'lastLoggedIn',
    },
    [ViewFieldKey_1.default.STAFF_ENABLED]: {
        key: ViewFieldKey_1.default.STAFF_ENABLED,
        fieldType: BasicFieldType_1.default.STAFF_ENABLED,
        propertyName: 'enabled',
        label: () => lib_i18n_1.default.t('enabled'),
        description: () => lib_i18n_1.default.t('enabled-description'),
        sortable: false,
        width: 100,
        gqlFields: 'enabled ',
    },
};
exports.default = exports.StaffViewFields;
